export const GET_NUMBER_OF_RECEIPTS_REQUEST = 'GET_NUMBER_OF_RECEIPTS_REQUEST'
export const GET_NUMBER_OF_RECEIPTS_SUCCESS = 'GET_NUMBER_OF_RECEIPTS_SUCCESS'
export const GET_NUMBER_OF_RECEIPTS_FAIL = 'GET_NUMBER_OF_RECEIPTS_FAIL'

export const GET_RECEIPT_METAINFO_REQUEST = 'GET_RECEIPT_METAINFO_REQUEST'
export const GET_RECEIPT_METAINFO_SUCCESS = 'GET_RECEIPT_METAINFO_SUCCESS'
export const GET_RECEIPT_METAINFO_FAIL = 'GET_RECEIPT_METAINFO_FAIL'
